import { AuthUserResponse, LoginResponse } from '@/api/auth/types';
import { Roles, AuthUser } from '../../core/types';

export const LOGIN_ROUTE_INDICATOR = 'login';

const LOCAL_STORAGE_AUTH_DATA_KEY = 'authData';

export interface AuthData {
	accessToken: string;
}

export const getAuthDataFromLoginResponse = (loginResponse: LoginResponse): AuthData => ({
	accessToken: loginResponse.access_token,
});

export const saveAuthData = (authData: AuthData): void => {
	localStorage.setItem(LOCAL_STORAGE_AUTH_DATA_KEY, JSON.stringify(authData));
};

export const removeAuthData = (): void => {
	localStorage.removeItem(LOCAL_STORAGE_AUTH_DATA_KEY);
};

export const getAuthData = (): AuthData | null => {
	const authDataRaw = localStorage.getItem(LOCAL_STORAGE_AUTH_DATA_KEY);
	if (!authDataRaw) return null;
	const authData: AuthData = JSON.parse(authDataRaw) as AuthData;

	return authData;
};

export const getAuthUserFromResponse = (authUserResponse: AuthUserResponse): AuthUser => ({
	id: authUserResponse.id,
	email: authUserResponse.email,
	firstName: authUserResponse.firstName,
	lastName: authUserResponse.lastName,
	role: authUserResponse.role.title as Roles,
	customerId: authUserResponse.customerId,
	pin: authUserResponse.pin,
	sites: authUserResponse.sites,
	customer: authUserResponse.customer,
	spoofedById: authUserResponse.spoofedById,
});
